import Modal from "common/components/Modal";
import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import { toast } from "react-toastify";

const AddRemark = ({ isOpen, onClose, title = "Add New Property" }) => {
  const [remarks, setRemarks] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("", {
        action: "completeTodo",
        todoId: isOpen,
        remarks,
      });
      if (data?.success) {
        onClose();
        toast.success(data?.msg);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Modal {...{ title: "Add Todo", isOpen, onClose }}>
      {/* <h6>
        <span className="text-muted">Task: </span>
        {title}
      </h6> */}
      <form onSubmit={handleSubmit}>
        <label>
          <span className="label">Remark</span>
          <input
            type="text"
            className="form-control"
            placeholder="Remark"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </label>
        <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
          <button type="button" className="btn btn-light me-2">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Add
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddRemark;
